export const CONTEXT_PATH = "jpl";
export const SOCKET_URL= "http://localhost:8080/ws";
export const BASE_URL= "https://api.jpl-solutions.tech/public/";
export const BASE_URL_LOCAL= "http://localhost:8080/";
export const SOCKET_HOST= "http://app.chatelaintours.com";
export const SOCKET_AUTH= "http://app.chatelaintours.com/api/public/api/broadcasting/auth";
